export default function () {
  return {
    current: {
      id: '',
      acm: {},
      active: '',
      boschPanel: {},
      building: '',
      dhcp: '',
      gateway: '',
      info: {},
      informaCastFusion: {},
      lockdownFromAccessCtrlIntrusionOk: null,
      lockdownToAccessCtrlIntrusionOk: null,
      restoreFromAccessCtrlIntrusionOk: null,
      restoreToAccessCtrlIntrusionOk: null,
      ipAddress: '',
      lockdownLogs: [],
      messageTemplates: {},
      name: '',
      reenableTime: null,
      restoreLogs: [],
      server: '',
      subnetMask: '',
      system: ''
    },
    update: {
      active: false,
      reenableTime: null
    },
    list: [],
    canInactivateForever: true
  }
}
